import "../base";
import { Section } from "../tools/section";
import { CLASS_ACTIVE, CLASS_HIDDEN, CLASS_DISABLED, CLASS_VISIBLE, CLASS_HAS_VALUE } from "../tools/constants/classes";

const SELECTOR_CONTAINER = '[data-registration-section]';
const SELECTOR_FIELD_GROUP = '[data-field-group]';
const SELECTOR_FORM = '[data-form]';
const SELECTOR_ERROR_LABEL = '[data-error-label]';
const SELECTOR_VERIFYING_LABEL = '[data-verifying-label]';
const SELECTOR_INPUT = '[data-input]';
const SELECTOR_FORM_INFO = '[data-form-info]';
const SELECTOR_SUBMIT_BTN = '[data-submit]';
const SELECTOR_SUCCESS_MSG = '[data-success-message]';
const SELECTOR_SIGNED_IN_MSG = '[data-signed-in-message]';
const SELECTOR_PREV = '[data-prev]';
const SELECTOR_NEXT = '[data-next]';
const SELECTOR_FORM_STEP = '[data-step]';
const SELECTOR_STEP_PROGRESS = '[data-form-progress]';
const SELECTOR_PHONE_FIELD = '[data-phone-field]';
const SELECTOR_COUNTRY_CODE = '[data-phone-display]';
const SELECTOR_PHONE_OUTPUT = '[data-phone-final-input]';
const SELECTOR_FILE_INPUT = '[data-file-input]';
const SELECTOR_DUMMY_SELECT = '[data-dummy-select]';
const SELECTOR_DUMMY_SELECT_TEXT = '[data-dummy-select-text]';
const SELECTOR_DUMMY_SELECT_DROPDOWN= '[data-dummy-select-dropdown]';
const SELECTOR_DUMMY_SELECT_OPTION = '[data-dummy-select-option]';
const SELECTOR_REAL_SELECT = '[data-real-select]';

const ERROR_MESSAGE_REQUIRED = "Please complete this required field.";
const ERROR_MESSAGE_EMAIL_FORMAT = "Email must be formatted correctly.";
const PREV_CLASS = 'is-prev';

const ATTR_ACTIVE_STEP = 'data-active-step';
const ATTR_STEP = 'data-step';
const ATTR_DUMMY_SELECT_OPTION = 'data-dummy-select-option';
const ATTR_INPUT_SIZE_LIMIT = 'data-size-limit';
const ATTR_INPUT_SIZE_LIMIT_WARNING = 'data-size-limit-warning';

// TO DO: in the future, pull these data from theme settings
const specific_conditions = [
  {
    step_to_hide: "main_contact_new",
    conditional_step_name: "is_main_contact",
    conditional_step_value: "Yes"
  },
  {
    step_to_hide: "province",
    conditional_step_name: "country_new",
    conditional_step_value: "United States"
  },
  {
    step_to_hide: "state_new",
    conditional_step_name: "country_new",
    conditional_step_value: "Canada"
  }
]

class RegistrationForm extends Section {
  private fieldGroups: NodeListOf<HTMLElement> | null = null
  private registrationForm: HTMLFormElement | null = null
  private inputFields: NodeListOf<HTMLElement> | null = null
  private errorLabel: HTMLElement | null = null
  private verifyingLabel: HTMLElement | null = null
  private formInfoElement: HTMLScriptElement | null = null;
  private submitBtn: HTMLButtonElement | null = null;
  private successMessage: HTMLElement | null = null;
  private signedInMessage: HTMLElement | null = null;
  private formPrev: HTMLButtonElement | null = null;
  private formNext: NodeListOf<HTMLButtonElement> | null = null;
  private formSteps: NodeListOf<HTMLElement> | null = null;
  private totalSteps: number = 1;
  private formProgress: HTMLElement | null = null
  private phoneFields: NodeListOf<HTMLInputElement> | null = null;
  private fileInput: NodeListOf<HTMLInputElement> | null = null;
  private phoneOutput: HTMLInputElement | null = null;
  private dummySelectTexts: NodeListOf<HTMLElement> | null = null;
  private dummySelectOptions: NodeListOf<HTMLElement> | null = null;
  private dummySelectDropdowns: NodeListOf<HTMLElement> | null = null;
  private portalId: string | null = null;
  private formGuid: string | null = null;
  private listId: string | null = null;
  private fileData: { [key: string]: string } = {};
  private uploadedFiles: string[] = [];

  queryChildren(container: HTMLElement): void {
    this.fieldGroups = container.querySelectorAll(SELECTOR_FIELD_GROUP);
    this.inputFields = container.querySelectorAll(SELECTOR_INPUT);
    this.registrationForm = container.querySelector(SELECTOR_FORM);
    this.formInfoElement = container.querySelector(SELECTOR_FORM_INFO);
    this.submitBtn = container.querySelector(SELECTOR_SUBMIT_BTN);
    this.successMessage = container.querySelector(SELECTOR_SUCCESS_MSG);
    this.signedInMessage = container.querySelector(SELECTOR_SIGNED_IN_MSG);
    this.formPrev = container.querySelector(SELECTOR_PREV);
    this.formNext = container.querySelectorAll(SELECTOR_NEXT);
    this.formSteps = container.querySelectorAll(SELECTOR_FORM_STEP);
    this.totalSteps = this.formSteps.length;
    this.formProgress = this.container.querySelector(SELECTOR_STEP_PROGRESS);
    this.phoneFields = container.querySelectorAll(SELECTOR_PHONE_FIELD);
    this.fileInput = container.querySelectorAll(SELECTOR_FILE_INPUT);
    this.dummySelectTexts = container.querySelectorAll(SELECTOR_DUMMY_SELECT_TEXT);
    this.dummySelectOptions = container.querySelectorAll(SELECTOR_DUMMY_SELECT_OPTION);
    this.dummySelectDropdowns = container.querySelectorAll(SELECTOR_DUMMY_SELECT_DROPDOWN);
    this.loadFormData();
  }

  attachEvents(): void {
    if (!this.formInfoElement) return;

    document.addEventListener('click', (e) => this.hideSelectDropdown(e));
    this.registrationForm?.addEventListener('submit', this.onFormSubmit);
    this.registrationForm?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault(); // Prevent form submission on Enter key press
        this.onNextClick(e);
        return false;
      }
    });
    this.submitBtn?.addEventListener('click', (e) => this.validateFields(e));
    this.formPrev?.addEventListener('click', this.onPrevClick);
    this.initialisePhoneInput();

    this.formNext?.forEach(next => {
      next.addEventListener('click', this.onNextClick);
    });
    this.dummySelectTexts?.forEach(text => {
      text.addEventListener('click', this.onSelectTextClick);
    });
    this.dummySelectOptions?.forEach(option => {
      option.addEventListener('click',(e) => this.onSelectOptionClick(e));
    });
  }

  loadFormData() {
    if (!this.formInfoElement) return;
    
    const formInfo = JSON.parse(this.formInfoElement.innerHTML);
    this.portalId = formInfo.portal_id;
    this.formGuid = formInfo.form_id;
    if (formInfo.list_id) this.listId = formInfo.list_id;
  }

  async checkHubSpotEmailExistence(email) {
    try {
      const response = await fetch(`https://coc02-cocofloss-b2b-hubspot-integration.pro-cess.workers.dev?email=${email}`);
      const data = await response.json();

      if (data.exists) {
        if (this.listId && data.contact['list-memberships']) { // If listId exists, check email's existence from that list only
          const contactLists = data.contact['list-memberships'];
          const listId = Number(this.listId);
          const exists = contactLists.some(item => item["static-list-id"] === listId);

          return exists; // Return email existence within list only
        } else {
          return true; // Return true if email exists within all Hubspot contacts
        }
      } else {
        return false; // Return false if email does not exist within all Hubspot contacts
      }
    } catch (error) {
      console.error('Error:', error);
      return false; // In case of an error, return false
    }
  }

  checkConditionalSlides() {
    this.formSteps?.forEach(step => {
      step.classList.remove(CLASS_HIDDEN);
    });

    specific_conditions.forEach(condition => {
      const {step_to_hide, conditional_step_name, conditional_step_value} = condition;
      const checkedRadio = this.container.querySelector(`input[name="${conditional_step_name}"]:checked`) as HTMLInputElement;
      const checkedValue = checkedRadio ? checkedRadio.value : null;

      if (checkedValue == conditional_step_value) {
        const stepToHide = this.container.querySelector(`[data-step-name="${step_to_hide}"]`);
        stepToHide?.classList.add(CLASS_HIDDEN);
      }
    });

    this.setStepsNumbering();
  }

  setStepsNumbering() {
    let stepNumber = 1;

    this.formSteps?.forEach(step => {
      if (!step.classList.contains('is-hidden')) {
        const stepDisplay = step.querySelector<HTMLSpanElement>('[data-step-number-display]');
        if (stepDisplay) {
          stepDisplay.textContent = stepNumber.toString();
          stepNumber++; // Increment step number for the next visible group
        }
      }
    });
  }

  initialisePhoneInput() {
    this.phoneFields?.forEach(field => {
      const input = field.querySelector(SELECTOR_INPUT) as HTMLInputElement;
      const countryCodeDisplay = field.querySelector(SELECTOR_COUNTRY_CODE) as HTMLInputElement;
      this.phoneOutput = field.querySelector(SELECTOR_PHONE_OUTPUT);

      if (input && countryCodeDisplay) {
        const iti = window.intlTelInput(input, {
          initialCountry: "auto",
          geoIpLookup: callback => {
            fetch('https://get.geojs.io/v1/ip/geo.json')
              .then(resp => resp.json())
              .then(data => callback(data.country_code))
              .catch(() => callback("us"));
          },
          utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
          autoPlaceholder: "off"
        });

        const updateOutput = () => {
          const countryData = iti.getSelectedCountryData();
          const countryCode = "+" + countryData.dialCode;
          countryCodeDisplay.innerText = countryCode;
          if (this.phoneOutput) this.phoneOutput.value = countryCode + input.value;
        };

        // Update on country change and keyup
        field.addEventListener('countrychange', updateOutput);
        input.addEventListener('keyup', updateOutput);
      }
    });
  }

  onFormSubmit = (e: Event) => {
    e.preventDefault();
    return false; // Disable manual form submit
  }

  onPrevClick = (e: Event) => {
    e.preventDefault();
    this.checkConditionalSlides();

    const index = Number(this.registrationForm?.getAttribute(ATTR_ACTIVE_STEP));
    if (!index || index < 2) return;
    let previousStepIndex = index - 1;

    const nextFieldGroup = this.registrationForm?.querySelector(`[${ATTR_STEP}="${previousStepIndex}"]`);
    if (nextFieldGroup?.classList.contains(CLASS_HIDDEN)) previousStepIndex--;

    this.registrationForm?.setAttribute(ATTR_ACTIVE_STEP, String(previousStepIndex));
    this.updateStep(previousStepIndex);
  }

  onNextClick = (e: Event) => {
    e.preventDefault();
    this.checkConditionalSlides();

    const index = Number(this.registrationForm?.getAttribute(ATTR_ACTIVE_STEP));
    if (!index) return;
    const inputField = this.registrationForm?.querySelector(`[${ATTR_STEP}="${index}"] ${SELECTOR_INPUT}`);
    let nextStepIndex = index + 1;

    const nextFieldGroup = this.registrationForm?.querySelector(`[${ATTR_STEP}="${nextStepIndex}"]`);
    if (nextFieldGroup?.classList.contains(CLASS_HIDDEN)) nextStepIndex++;

    if (index < this.totalSteps) {
      this.validateSingleField(inputField, nextStepIndex);
    } else {
      this.validateFields(e);
    }
  }

  updateStep = (index: number) => {
    const progress = (index / this.totalSteps) * 100;
    this.formSteps?.forEach(step => {
      const stepID = Number(step.getAttribute(ATTR_STEP));
      step.classList.remove(CLASS_ACTIVE);
      stepID < index ? step.classList.add(PREV_CLASS) : step.classList.remove(PREV_CLASS);
    });
    index > 1 ? this.formPrev?.classList.remove(CLASS_DISABLED) : this.formPrev?.classList.add(CLASS_DISABLED);
    this.formNext?.forEach(next => {

      if (this.totalSteps == index) { // Last slide
        next.classList.add(CLASS_DISABLED);
        next.classList.remove(CLASS_VISIBLE);
        this.submitBtn?.classList.add(CLASS_VISIBLE);
      } else {
        next.classList.remove(CLASS_DISABLED);
        next.classList.add(CLASS_VISIBLE);
        this.submitBtn?.classList.remove(CLASS_VISIBLE);
      }
    });
    this.formProgress?.style.setProperty('--progress-width', `${String(progress)}%`);
    this.registrationForm?.querySelector(`[${ATTR_STEP}="${index}"]`)?.classList.add(CLASS_ACTIVE);
    this.registrationForm?.setAttribute(ATTR_ACTIVE_STEP, String(index));
  }

  onSelectTextClick(e: Event) {
    const selectText = e.currentTarget as HTMLElement;
    const selectElement = selectText.closest(SELECTOR_DUMMY_SELECT);

    if (!selectElement) return;
    const selectDropdown = selectElement.querySelector(SELECTOR_DUMMY_SELECT_DROPDOWN);
    selectDropdown?.classList.toggle(CLASS_HIDDEN);
  }

  onSelectOptionClick(e: Event) {
    const selectOption = e.currentTarget as HTMLElement;
    const selectElement = selectOption.closest(SELECTOR_DUMMY_SELECT);
    const selectOptionValue = selectOption.getAttribute(ATTR_DUMMY_SELECT_OPTION);
    const fieldGroup = selectOption.closest(SELECTOR_FIELD_GROUP);

    this.dummySelectOptions?.forEach(option => {
      option.classList.remove(CLASS_ACTIVE);
    });
    selectOption.classList.add(CLASS_ACTIVE);

    if (!selectElement) return;
    const selectDropdown = selectElement.querySelector(SELECTOR_DUMMY_SELECT_DROPDOWN);
    const selectText = selectElement.querySelector(SELECTOR_DUMMY_SELECT_TEXT) as HTMLElement;
    selectDropdown?.classList.add(CLASS_HIDDEN);

    if (selectText && selectOptionValue) {
      selectText.innerText = selectOptionValue;
      selectText.classList.add(CLASS_HAS_VALUE);

      if (fieldGroup) {
        const selectReal = fieldGroup.querySelector(SELECTOR_REAL_SELECT) as HTMLSelectElement;
        selectReal.value = selectOptionValue;
      }
    }
  }

  hideSelectDropdown(e: Event) {
    e.stopPropagation();
    const target = e.target as HTMLElement;
    const selectDropdown = target.closest(SELECTOR_DUMMY_SELECT_DROPDOWN);
    const selectText = target.closest(SELECTOR_DUMMY_SELECT_TEXT);
    if (selectDropdown || selectText) return;
    
    this.dummySelectDropdowns?.forEach(dropdown => {
      dropdown.classList.add(CLASS_HIDDEN);
    });
  }

  setVerifyingLabel(field: HTMLElement, state?: String) {
    this.verifyingLabel = field.querySelector(SELECTOR_VERIFYING_LABEL);

    if (this.verifyingLabel) {
      if (state == 'complete') {
        this.verifyingLabel.innerText = "Email address verified ✔"

        setTimeout(() => {
          this.verifyingLabel?.classList.remove(CLASS_ACTIVE);
        }, 500);
      } else {
        this.verifyingLabel.classList.add(CLASS_ACTIVE);
        this.verifyingLabel.innerText = "Verifying email address..."
      }
    }
  }

  validateSingleField = async (input: any, index?: number) => {
    let field = input.closest(SELECTOR_FIELD_GROUP) as HTMLElement;

    if (!field) return;
    this.errorLabel = field.querySelector(SELECTOR_ERROR_LABEL);

    if (!this.errorLabel) return;

    if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) {
      if (!input.checkValidity()) {
        if (input.validity.patternMismatch) {
          this.errorLabel.innerText = ERROR_MESSAGE_EMAIL_FORMAT;
        } else {
          this.errorLabel.innerText = ERROR_MESSAGE_REQUIRED;
        }
        // If the field is invalid, show error label
        this.errorLabel.classList.add(CLASS_ACTIVE);
        setTimeout(() => {
          this.errorLabel?.classList.remove(CLASS_ACTIVE);
        }, 3000);
      } else {
        if (input.type === 'email') {
          this.setVerifyingLabel(field);
          const encodedValue = encodeURIComponent(input.value);
          const emailExists = await this.checkHubSpotEmailExistence(encodedValue);
          this.setVerifyingLabel(field, 'complete');

          // Show error if email check fails
          if (emailExists) {
            this.registrationForm?.classList.add(CLASS_HIDDEN);
            this.signedInMessage?.classList.add(CLASS_ACTIVE);
            return;
          } else {
            setTimeout(() => { // Added delay to show verification status first
              this.errorLabel?.classList.remove(CLASS_ACTIVE);
              if (index) this.updateStep(index);
            }, 500);
          }
        } else if (input.type == 'file') {
          const file = input.files ? input.files[0] : null;
          const fileLimitAttr = input.getAttribute(ATTR_INPUT_SIZE_LIMIT);
          const fileLimitWarningAttr = input.getAttribute(ATTR_INPUT_SIZE_LIMIT_WARNING) || 'File size exceeds the 20MB limit';
          const fileLimit = fileLimitAttr ? parseInt(fileLimitAttr) : 20;
  
          // Check if a file is selected and its size
          if (file && file.size > fileLimit * 1024 * 1024) {
            this.errorLabel.innerText = fileLimitWarningAttr.replace('%file_limit%',fileLimit.toString());
            this.errorLabel.classList.add(CLASS_ACTIVE);
            setTimeout(() => {
              this.errorLabel?.classList.remove(CLASS_ACTIVE);
            }, 3000);
          } else {
            // No errors
            this.errorLabel.classList.remove(CLASS_ACTIVE);
            if (index) this.updateStep(index);

            // Attempt file upload
            this.fileUploads();
          }
        } else {
          this.errorLabel.classList.remove(CLASS_ACTIVE);
          if (index) this.updateStep(index);
        }
      }
    }
  }

  fileUploads() {
    const fileInputs = this.container.querySelectorAll<HTMLInputElement>('input[type="file"][required]');
    let isValid = true;

    fileInputs.forEach((fileInput) => {
      // Check if each file input has a value
      if (!fileInput.files || fileInput.files.length === 0) {
        isValid = false;
      }
    });

    // Only upload if all file input are filled out
    if (isValid) {
      this.submitFile();
    }
  }

  validateFields(e: Event) {
    let hasInvalidField = false;
    let invalidFields = 0;

    this.fieldGroups?.forEach(field => {
      // Find all input, select, and radio button elements inside the group
      this.inputFields = field.querySelectorAll(SELECTOR_INPUT);
      this.errorLabel = field.querySelector(SELECTOR_ERROR_LABEL);

      // Loop through each input field and check validity
      this.inputFields?.forEach(input => {
        if (!this.errorLabel) return;

        if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement) {
          if (!input.checkValidity()) {
            invalidFields += 1;

            // Set error message
            if (input.validity.patternMismatch) {
              this.errorLabel.innerText = ERROR_MESSAGE_EMAIL_FORMAT;
            } else {
              this.errorLabel.innerText = ERROR_MESSAGE_REQUIRED;
            }

            // If the field is invalid, show error label
            this.errorLabel.classList.add(CLASS_ACTIVE);
            hasInvalidField = true;
          } else {
            this.errorLabel.classList.remove(CLASS_ACTIVE);
          }
        }
      });
    });

    if (!hasInvalidField) {
      this.submitForm(e);
    } else {
      return false;
    }
  }

  detatchEvents() {
    this.registrationForm?.removeEventListener('submit', this.onFormSubmit);

    this.formPrev?.removeEventListener('click', this.onPrevClick);
    this.formNext?.forEach(next => {
      next.removeEventListener('click', this.onNextClick);
    });
  }

  async getIPAddress() {
    try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
    } catch (error) {
      console.error('Unable to retrieve IP address:', error);
      return null;
    }
  }

  async submitFile() {
    try {
      const newFormData = new FormData(); // Create a new FormData instance
      let filesToUpload = 0;
  
      this.fileInput?.forEach(fileInput => {
        const files = fileInput.files;
  
        // Check if files exist and loop through them
        if (files) {
          Array.from(files).forEach(file => {
            // Prevent uploading the same file by checking its name in the array
            if (!this.uploadedFiles.includes(file.name)) {
              newFormData.append("file", file);
              this.uploadedFiles.push(file.name);
              filesToUpload++;
            }
          });
        }
      });

      if (filesToUpload == 0) return;
  
      // Send the formData to Cloudflare Worker
      const response = await fetch("https://coc02-cocofloss-b2b-hubspot-integration.pro-cess.workers.dev", {
        method: "POST",
        body: newFormData
      });
  
      if (response.ok) {
        const responseBody = await response.json();
        let fileUrls: string[] = [];
  
        // Loop through each file upload response to extract URLs
        responseBody.forEach(fileResponse => {
          if (fileResponse.data && Array.isArray(fileResponse.data.objects)) {
            const urls: string[] = fileResponse.data.objects.map((obj: { url: string }) => obj.url);
            fileUrls = fileUrls.concat(urls);
          }
        });
  
        this.fileData = {};
  
        // Iterate over file inputs and map them to their corresponding URLs
        this.fileInput?.forEach((input, index) => {
          const inputName = input.getAttribute('data-name');
          if (inputName && fileUrls[index]) {
            this.fileData[inputName] = fileUrls[index];
          }
        });
      } else {
        console.error("File upload failed with status:", response.status);
        alert("File upload failed");
      }
    } catch (error) {
      console.error("An error occurred during the file upload process:", error);
      alert("An error occurred during the file upload process. Please try again.");
    }
  }

  async submitForm(e: Event) {
    if (this.submitBtn) this.submitBtn.innerText = "Submitting...";

    // Gather form data
    if (!this.registrationForm) return;
    const formData = new FormData(this.registrationForm);

    // Get the user's IP address
    const ipAddress = await this.getIPAddress();

    // Get cookies
    const hubspotUTK = this.getHubSpotUTK();

    const data = {
      fields: Array.from(formData.entries()).map(([name, value]) => ({ name, value })),
      context: {
        pageUri: `${window.location.href}`,
        pageName: `${window.location.pathname}`,
        ipAddress: `${ipAddress}`,
        hutk: hubspotUTK
      },
    };

    if (this.fileData) {
      Object.entries(this.fileData).forEach(([inputName, fileUrl]) => {
        data.fields.push({ name: inputName, value: fileUrl as FormDataEntryValue });
      });
    }

    if (!this.portalId || !this.formGuid) return;

    // Submit data to HubSpot
    fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${this.portalId}/${this.formGuid}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (this.submitBtn) {
          this.submitBtn.innerText = "Submit";
          this.registrationForm?.classList.add(CLASS_HIDDEN);
          this.successMessage?.classList.add(CLASS_ACTIVE);
          
          // Scroll to top
          const offset = 170;
          const topPosition = this.successMessage ? this.successMessage.getBoundingClientRect().top + window.scrollY - offset : 0;
          window.scrollTo({ top: topPosition, behavior: 'smooth' });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  getHubSpotUTK() {
    const name = "hubspotutk=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArr = decodedCookie.split(';');

    for (let i = 0; i < cookieArr.length; i++) {
      let cookie = cookieArr[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return null;
  }
}

Section.register(SELECTOR_CONTAINER, RegistrationForm);